var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPrescribing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "b",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 40.83,
    height: 41.2,
    viewBox: "0 0 40.83 41.2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "c",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 3.677,
    y: 0.65,
    width: 18.533,
    height: 8.383,
    rx: 2.661,
    ry: 2.661,
    fill: "none",
    stroke: "#73307a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.236,26.578v-5.662c0-.588-.178-1.161-.508-1.636l-3.991-5.749c-.33-.475-.508-1.048-.508-1.636v-2.777s0-.002-.002-.002",
    fill: "none",
    stroke: "#73307a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.659,9.114s-.002.001-.002.002v2.777c0,.588-.178,1.161-.508,1.636l-3.991,5.749c-.33.475-.508,1.048-.508,1.636v16.855c0,1.535,1.186,2.78,2.65,2.78h19.287c.423,0,.823-.104,1.178-.289",
    fill: "none",
    stroke: "#73307a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 24.922,
    y1: 22.049,
    x2: 1.606,
    y2: 22.049,
    fill: "none",
    stroke: "#73307a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 13.077,
    y1: 26.144,
    x2: 13.077,
    y2: 31.061,
    fill: "none",
    stroke: "#73307a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 15.356,
    y1: 28.603,
    x2: 10.798,
    y2: 28.603,
    fill: "none",
    stroke: "#73307a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 20.251,
    y1: 35.108,
    x2: 1.606,
    y2: 35.108,
    fill: "none",
    stroke: "#73307a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.495,30.349c2.246-2.246,2.246-5.921,0-8.168-2.246-2.246-5.921-2.246-8.168,0l-4.212,4.212,8.168,8.168,4.212-4.212Z",
    fill: "none",
    stroke: "#73307a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.115,26.394l-4.263,4.263c-2.246,2.246-2.246,5.921,0,8.168,2.246,2.246,5.921,2.246,8.168,0l4.263-4.263-8.168-8.168Z",
    fill: "none",
    stroke: "#73307a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrescribing);
export default __webpack_public_path__ + "static/media/prescribing.0ff97e92.svg";
export { ForwardRef as ReactComponent };